<div class="joint-app">
  <div class="app-header">
    <div class="toolbar-container joint-theme-light"></div>
  </div>
  <div class="app-body">
    <div [ngClass]="{'display-none': readOnly}" class="stencil-container"></div>
    <div class="paper-container bordered"></div>
    <div [ngClass]="{'display-none': readOnly}" class="inspector-container"></div>
    <div [ngClass]="{'display-none': readOnly}" class="navigator-container"></div>
  </div>
</div>
